<template>
  <GlobalWindow
    :visible.sync="isVisibled"
    :show="true"
    title="复制列表"
    width="80%"
    @confirm="confirm"
  >
    <div class="app-container">
      <el-card style="box-shadow:none;    border:none;">
        <!--  <div
          slot="header"
          class="header"
        >
          <span>复制广告(Mp)</span>
          <span>广告主：《{{ this.$route.query.account_name }}》&nbsp;&nbsp;<span>服务商：{{ this.$route.query.service_name }}</span></span>
        </div> -->
        <div class="top">
          <el-row :gutter="10">
            <el-col :span="4">
              <el-input
                v-model="mpAdvertListParams.keyword"
                placeholder="请输入广告ID"
              >
                <i
                  slot="prefix"
                  class="el-input__icon el-icon-search"
                />
              </el-input>
            </el-col>
            <el-button
              type="primary"
              @click="searchMpAdvert"
            >搜索</el-button>
            <el-button
              type="primary"
              @click="resetMpAdvertList"
            >重置</el-button>
          </el-row>
        </div>
        <div class="main">
          <el-table
            v-loading="loading"
            :data="mpAdvertList"
            style="width: 100%"
            :row-key="getRowKeys"
            @select="multipleChoice"
            @select-all="multipleChoice"
          >
            <el-table-column
              type="selection"
              width="55"
              :data-index="1"
              :reserve-selection="true"
            />
            <el-table-column
              prop="id"
              label="id"
              align="center"
            />
            <el-table-column
              prop="copy_num"
              label="复制数量"
              align="center"
            />
            <el-table-column
              prop="source_account_id"
              label="来源广告账户id"
              align="center"
              width="180"
            />
            <el-table-column
              prop="source_account_name"
              label="来源广告账户名称"
              align="center"
              width="230"
            />
            <el-table-column
              prop="source_adgroup_id"
              label="来源广告组id"
              align="center"
              width="180"
            >
              <template scope="scope">
                {{ scope.row.source_adgroup_id }}
              </template></el-table-column>
            <el-table-column
              prop="source_adgroup_name"
              label="来源广告组名称
"
              align="center"
              width="280"
            />
            <el-table-column
              prop="target_account_id"
              label="目标广告账户id"
              align="center"
            />
            <el-table-column
              prop="target_account_name"
              label="目标广告账户名称
"
              align="center"
            />
            <el-table-column
              prop="status"
              label="状态"
              align="center"
            >
              <template scope="scope">
                {{ scope.row.status==1?'完成':scope.row.status==2? '终止':'待处理' }}
              </template></el-table-column>
            <el-table-column
              prop="remark"
              label="备注"
              align="center"
            />
            <el-table-column
              prop="copy_num"
              label="计划数量"
              align="center"
            />
            <el-table-column
              prop="success_num"
              label="成功数量"
              align="center"
            />

            <el-table-column
              prop="updated_at"
              label="更新时间"
              align="center"
            />
            <el-table-column
              prop="created_at"
              label="创建时间"
              align="center"
            />
            <!-- <el-table-column
              prop="ad_name"
              label="广告名称"
            />
            <el-table-column
              label="创意预览"
              align="center"
              width="200"
            >
              <template scope="scope">
                <div class="shadowBox">
                  <el-popover
                    v-if="!scope.row.preview_info.video"
                    placement="right"
                    width="120"
                    trigger="hover"
                  >
                    <el-image
                      :src="scope.row.preview_info.img"
                      :alt="scope.row.id"
                    />
                    <el-image
                      slot="reference"
                      ref="pic"
                      style="width: 100px;"
                      :src="scope.row.preview_info.img"
                    />
                  </el-popover>
                  <el-popover
                    v-if="scope.row.preview_info.video"
                    placement="right"
                    width="100px"
                    trigger="hover"
                  >
                    <el-image
                      slot="reference"
                      style="width: 100px;"
                      :src="scope.row.preview_info.img"
                    />
                    <video
                      ref="video"
                      :src="scope.row.preview_info.video"
                      autoplay
                      loop
                      muted
                      style="width: 100px; height: 100px; object-fit: fill"
                    />
                  </el-popover>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="ad_id"
              label="广告ID"
              align="center"
            /> -->
            <!-- <el-table-column
              label="操作"
              align="center"
              width="200"
            > -->
            <!-- <template scope="scope">
                <el-button
                  type="warning"
                  size="mini"
                  @click="handleCopyTencentAdqAdver(scope.row.adgroup_id)"
                >
                  复制
                </el-button>
              </template> -->
            <!-- </el-table-column> -->
          </el-table>
          <!-- <publicAdvertList ref="publicAdvertList" />
            -->
          <CopyMpAdDialog ref="copyMpAdDialog" />
          <Pagination
            :total="pageTotal"
            :page.sync="mpAdvertListParams.page"
            :limit.sync="mpAdvertListParams.page_size"
            :page-sizes="[mpAdvertListParams.page_size]"
            @pagination="fetchMpAdvertList"
          />
        </div>
      </el-card>
    </div>
  </GlobalWindow>
</template>

<script>
import Pagination from '@/components/Pagination/index'
import { job_list } from '@/api/customer.js'

// import publicAdvertList from '@/views/customer/accountList/tencentAdqAdvertManage/publicAdvertList'
import CopyMpAdDialog from '@/views/customer/accountList/tencentAdqAdvertManage/CopyMpAdvertManage/CopyMpAdDialog/index.vue'
// import MpAdDetailDrawer from '@/views/customer/accountList/tencentAdqAdvertManage/CopyMpAdvertManage/MpAdDetailDrawer/index.vue'
// import MpAdvertPreview from '@/views/customer/accountList/tencentAdqAdvertManage/CopyMpAdvertManage/components/MpAdvertPreview.vue'
import GlobalWindow from '@/components/GlobalWindow.vue'
export default {
  name: 'CopyMpAdvertManage',
  components: {
    Pagination,
    // publicAdvertList,
    CopyMpAdDialog,
    // MpAdDetailDrawer,
    /* MpAdvertPreview ,*/
    GlobalWindow
  },
  data() {
    return {
      isVisibled: false,
      loading: false,
      drawerTitle: null,
      pageTotal: 0,
      isDetailStatus: false,
      mpAdvertListParams: {
        account_id: this.$route.query.account_id,
        keyword: null,
        page: 1,
        page_size: 7
      },
      mpAdvertList: [],
      isShow: false
    }
  },
  created() {},
  methods: {
    multipleChoice(arr) {
      this.adgroup_ids = arr.map(item => {
        return item.adgroup_id
      })
      this.adgroup_items = arr
    },
    // 获取广告列表
    fetchMpAdvertList() {
      this.loading = true
      this.isShow = false
      job_list(this.mpAdvertListParams).then(res => {
        console.log(res)
        this.mpAdvertList = res.data.list
        this.pageTotal = res.data.total
        this.loading = false
        // const asyncParams = {
        //   account_id: this.$route.query.account_id,
        //   campaign_ids: []
        // }
        // res.data.list.forEach(item => {
        //   asyncParams.campaign_ids.push(item.ad_id)
        //   item.isDetailStatus = false
        //   this.isShow = true
        // })
        // if (res.data.list.length) {
        //   // this.fetchMpAdvertListAsyncData(asyncParams)
        // }
      })
    },
    // 获取广告异步数据
    // fetchMpAdvertListAsyncData(params) {
    //   this.isShow = false
    //   mpAdvertListAsyncData(params).then(res => {
    //     console.log(res, '===')
    //     this.mpAdvertList.map((item, index) => {
    //       res.data.map(ite => {
    //         if (item.ad_id === ite.campaign_id) {
    //           item.asyncData = ite
    //         }
    //       })
    //     })
    //     this.isShow = true
    //   })
    // },
    // 判断数据是否刷新完成
    isFreshOk() {
      /* if (!this.isShow) {
        this.$message({
          message: '请等待数据刷新完成',
          type: 'error'
        })
        return false
      } */
      return true
    },
    getRowKeys(row) {
      return row.id
    },
    handleCopyMpAdvert(rowData) {
      console.log('rowData:', rowData)
      if (this.isFreshOk()) {
        this.$refs.copyMpAdDialog.open(rowData)
      }
    },
    // 搜索广告
    searchMpAdvert() {
      this.mpAdvertListParams.page = 1
      this.fetchMpAdvertList()
    },
    // 重置广告列表
    resetMpAdvertList() {
      this.mpAdvertListParams = {
        account_id: this.$route.query.account_id,
        campaign_id: null,
        page: 1,
        page_size: 5
      }
      this.fetchMpAdvertList()
    },
    handleShowDetail(index, row) {
      this.$set(this.mpAdvertList, index, { ...row, isDetailStatus: true })
    },
    open() {
      this.isVisibled = true
      this.fetchMpAdvertList()
    },
    confirm() {
      console.log('this.copyMpAdvertParams:', this.copyMpAdvertParams)
      this.handleCopyMpAdvert(this.copyMpAdvertParams)
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  display: flex;
  justify-content: space-between;
}
.main {
  margin-top: 20px;
  video {
    width: 100px;
    height: 100px;
    object-fit: fill;
  }
  .shadowBox {
    display: flex;
    height: 100px;
    align-items: center;
    justify-content: center;
  }
}
.app-container {
  padding: 0px;
}
</style>
